"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chaosMonkey = void 0;
const getInstanceMethodNames_1 = require("../../../../helpers/getInstanceMethodNames");
/**
 * Given a client and probability (optional, defaults to 0.5), replace the methods on the
 * client that perform network requests with one that will error at the
 * given probability.
 *
 * Using a real client will cause network requests to fail, whereas using a
 * mock client will cause any client calls to fail (as the mock client doesn't
 * make network requests.)
 *
 * TODO Support websockets.
 */
const chaosMonkey = (
/** The client to use. */
client, // HACK unable to use IClient - not used by Next
/** A number between 0 & 1 that determines that chance of any network request
 * failing. */
probability = 0.5, usingRealClient) => {
    // let the user know the chaos monkey is on.
    console.log("🙈🙉🙊\nthe chaos monkey has been summoned...\n🙈🙉🙊");
    // for each module on the client...
    Object.entries(client).forEach(([moduleName, module]) => {
        // we don't want to affect these modules.
        // firstly, we aren't concerned with websockets currently.
        // secondly, instead of affecting httpConnection, we will affect methods
        // that use httpConnection.
        // we do this because some modules may use axios/fetch/etc directly instead
        // of this.httpConnection.makeRequest(...) or similar. So affecting those
        // modules is the best approach.
        if (moduleName === "httpConnection" ||
            moduleName === "webSocketConnection") {
            return;
        }
        // get the names of the methods of the given module.
        // this helper method gets the method names of an object, following the
        // prototype chain until the second parameter (in this case
        // Object.prototype) is reached.
        const methodNames = (0, getInstanceMethodNames_1.getInstanceMethodNames)(module, Object.prototype);
        // for each property in the module...
        methodNames
            // get a reference to the property itself
            .map(name => [name, module[name]])
            .forEach(([modulePropertyName, moduleProperty]) => {
            // only interested in functions
            if (typeof moduleProperty !== "function") {
                return;
            }
            // get the text of the method.
            const fnText = moduleProperty.toString();
            // we don't want to affect methods that use websockets (yet).
            const functionUsesWebsockets = fnText.toLowerCase().includes("synced");
            if (functionUsesWebsockets) {
                return;
            }
            // only check if method performs a network request if using real client.
            if (usingRealClient) {
                // this is a rough heuristic.
                // a method probably performs a network request if it contains one of
                // these strings in its function text.
                const functionPerformsNetworkRequest = fnText.includes("fetch") ||
                    fnText.includes("axios") ||
                    fnText.includes("httpConnection");
                // only interested in functions that perform network requests.
                if (!functionPerformsNetworkRequest) {
                    return;
                }
            }
            // replace the function with one that will randomly switch between
            // throwing an error or working as usual.
            client[moduleName][modulePropertyName] = (...args) => {
                if (Math.random() < probability) {
                    throw new Error(modulePropertyName);
                }
                else {
                    // ensure method has 'this' defined correctly.
                    return moduleProperty.call(client[moduleName], ...args);
                }
            };
        });
    });
};
exports.chaosMonkey = chaosMonkey;
//# sourceMappingURL=index.js.map